import { getErrorJsonData } from '../../sinks/utils/getErrorJsonData';
import { QosState } from './types';

/**
 * __For internal use only!__
 *
 * Create {@link ITelemetryQos} instances.
 *
 * Creates a stateful QoS telemetry reporter instance which enforces the correct QoS
 * telemetry event pattern for loading a single instance of a single feature.
 */
export function createQosTelemetryReporter(telemetry, target) {
  var startTime = Date.now();
  var state = QosState.IDLE;
  return {
    get state() {
      return state;
    },

    complete: function complete() {
      if (state === QosState.IDLE) {
        state = QosState.LOAD_COMPLETE;
        telemetry.reportQos(target, {
          action: state,
          loadTime: Math.max(0, Date.now() - startTime)
        });
      }
    },
    failure: function failure(error, failedComponent) {
      // Always log the actual error so we won't lose error logs
      telemetry.error("ComponentQoS/".concat(failedComponent || 'thrown-error'), error);

      if (state === QosState.IDLE) {
        state = QosState.LOAD_FAILURE;
      } else if (state === QosState.LOAD_COMPLETE) {
        state = QosState.UPDATE_FAILURE;
      } else {
        return;
      }

      telemetry.reportQos(target, {
        action: state,
        error: getErrorJsonData(error)
      });
    },
    timeout: function timeout() {
      if (state === QosState.IDLE) {
        state = QosState.TIMEOUT;
        telemetry.reportQos(target, {
          action: QosState.TIMEOUT
        });
      }
    }
  };
}
//# sourceMappingURL=createQosTelemetryReporter.js.map